import { confinementAllowedPrefixes } from "~/pwa/installableApps";
import { normalizeHost } from "~portal/helpers/hostClassification";

const BENCHMARK_HOSTS: ReadonlySet<string> = new Set([
	"benchmark.silverfern.com",
	"benchmark.silverfern.red",
	"benchmarkstage.silverfern.com"
]);

export const BENCHMARK_HOME_PATH = "/benchmark";

export const benchmarkHostAllowedPrefixes = [
	BENCHMARK_HOME_PATH,
	"/fernie",
	"/notifications",
	...confinementAllowedPrefixes,
	"/register"
];

export const isBenchmarkHostAllowedPath = (pathname: string): boolean =>
	benchmarkHostAllowedPrefixes.some((prefix) => pathname === prefix || pathname.startsWith(prefix + "/"));

const isBenchmarkHost = (host: string): boolean => BENCHMARK_HOSTS.has(normalizeHost(host));

export default isBenchmarkHost;
